'use strict';

const TIA_FIRST_TIER_KEY = 'assessment_facilitator';
const TIA_SECOND_TIER_KEY = 'growth_planner';
const TIA_PROGRESS_BADGE_SIZE = 24;

function getAcademyProgressBadgeProps(academySkillProgress) {
  const firstTierProgress = getTierCompletionPercentage(
    academySkillProgress,
    TIA_FIRST_TIER_KEY
  );
  const secondTierProgress = getTierCompletionPercentage(
    academySkillProgress,
    TIA_SECOND_TIER_KEY
  );

  if (secondTierProgress > 0) {
    return {
      variant: 'gold',
      progress: secondTierProgress,
      size: TIA_PROGRESS_BADGE_SIZE,
      ariaLabel: 'Growth Planner Academy tier progress'
    };
  }

  return {
    variant: 'silver',
    progress: firstTierProgress,
    size: TIA_PROGRESS_BADGE_SIZE,
    ariaLabel: 'Assessment Facilitator Academy tier progress'
  };
}

function getTierCompletionPercentage(academySkillProgress, tierKey) {
  if (!Array.isArray(academySkillProgress)) {
    return 0;
  }

  const tierProgress = academySkillProgress.find(function(progress) {
    return progress.tierKey === tierKey;
  });
  const completionPercentage = Number(
    tierProgress && tierProgress.completionPercentage
  );

  return Number.isFinite(completionPercentage) ? completionPercentage : 0;
}

(function () {

  var module = angular.module('client.components');

  controller.$inject = ['$location', 'ActiveMode', 'NgTableParams', 'reportLabels', 'noTypeReportsList', '$log', 'ReportNavigation',
                        'User', 'UserInfoDefaultFactory', 'reportToCSV', 'ReportingSchoolYearsService'];

  function controller($location, ActiveMode, NgTableParams, reportLabels, noTypeReportsList, $log, ReportNavigation,
                      User, UserInfoDefaultFactory, reportToCSV, ReportingSchoolYearsService) {

    var ctrl = this;

    ctrl.inited = false;
    ctrl.reportingTeachers = [];
    ctrl.filteredReportingTeachers = [];
    let allSchools = {id:'none', name:'All Schools'};
    ctrl.schools = [allSchools];
    ctrl.filterSchool = ctrl.schools[0];
    ctrl.filterYears = ReportingSchoolYearsService.get();
    ctrl.year = null;

    function getFilter() {
      var filter = {};
      filter.year = ctrl.year;
      return filter;
    }

    function initReportingYear() {
      ctrl.year = ctrl.filterYears[0].value;
    }

    ctrl.setSchool = function setSchool(selection) {
      ctrl.filterSchool = selection;
      filterReportingTeachers();
    };

    ctrl.onExpandSchool = function onExpandSchool(school, expand) {
      ctrl.filteredReportingTeachers.forEach(function(sch) {
        if (school.schoolId == sch.schoolId) {
          if (sch.isSchool) {
            sch.isExpanded = expand;
          } else {
            sch.isVisible = expand;
          }
        }
      });
    };

    function exportColumns() {
      var csvColumns = [];
      csvColumns.push(
        {
          name: 'Campus',
          field: 'schoolName',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Teacher Name',
          field: 'teacherName',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Teacher Email',
          field: 'teacherEmail',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Purchased Seats',
          field: 'purchased',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Licensed Seats',
          field: 'licensed',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Pre-test completed',
          field: 'pretest',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Post-test completed',
          field: 'posttest',
          wrap: true
        }
      );
      csvColumns.push(
        {
          name: 'Pre and Post (Same student)',
          field: 'prepostTest',
          wrap: true
        }
      );

      return csvColumns;
    }

    function exportData() {
      var csvRows = [];
      ctrl.reportingTeachers.forEach(function(teacher) {
        if (!teacher.isSchool) {
          let row = {
            schoolName: teacher.schoolName,
            teacherName: teacher.name,
            teacherEmail: teacher.email,
            purchased: teacher.purchased,
            licensed: teacher.seats,
            pretest: teacher.pretests,
            posttest: teacher.posttests,
            prepostTest: teacher.matchingPosttests
          };
        csvRows.push(row);
        }
      });

      return csvRows;
    }

    function exportFile() {
      return (ctrl.parent.title || 'TIA Progress Report') + '.csv';
    }

    ctrl.downloadCSV = function downloadCSV() {
      return ctrl.exportCSV();
    };

    ctrl.exportCSV = reportToCSV(
      function() { return exportColumns(); },
      function() { return exportData(); },
      function() { return exportFile(); },
      ','
    );

    function calculateSchoolTotals(report, school, index) {
      let record = {
          schoolId: school.id,
          schoolName: school.school_name,
          name: school.school_name,
          purchased: school.purchased,
          seats: school.usedSeats,
          pretests: 0,
          posttests: 0,
          matchingPosttests: 0,
          isSchool: true,
          isExpanded: (!ctrl.isDistrictReport || index == 0),
          isVisible: true
      }
      report.data.teachers.forEach(function(teacher) {
        if (school.id == teacher.school_id) {
          record.pretests = record.pretests + teacher.pretest_count;
          record.posttests = record.posttests + teacher.posttest_count;
          record.matchingPosttests = record.matchingPosttests + teacher.matchingPosttests;
        }
      });
      return record;
    }

    function filterReportingTeachers() {
      ctrl.filteredReportingTeachers = ctrl.reportingTeachers.filter(function(teacher) {
        return (ctrl.filterSchool.id == 'none' || ctrl.filterSchool.id == teacher.schoolId);
      });

      if (ctrl.filterSchool.id == 'none') {
        ctrl.seatsPurchased = ctrl.totalSeats.purchased;
        ctrl.seatsLicensed = ctrl.totalSeats.licensed;
        ctrl.pretestsCompleted = ctrl.totalTests.pretests;
        ctrl.posttestsCompleted = ctrl.totalTests.posttests;
      } else {
        let currentSchool = ctrl.reportingTeachers.find(function(rec) {
          return rec.isSchool && rec.schoolId == ctrl.filterSchool.id;
        });
        if (currentSchool) {
          ctrl.seatsPurchased = currentSchool.purchased;
          ctrl.seatsLicensed = currentSchool.seats;
          ctrl.pretestsCompleted = currentSchool.pretests;
          ctrl.posttestsCompleted = currentSchool.matchingPosttests;
        }
      }
    }

    function fetchAndUpdateReport() {
      ctrl.reportingTeachers = [];
      var filter = getFilter();
      ctrl.loadingData = true;
      return ActiveMode.getReportData(filter).then(function (report) {
        ctrl.loadingData = false;
        ctrl.parent.title = report.name || 'TIA Progress Report';
        ctrl.currentLevel = report.level;
        ctrl.totalSeats = report.data.seats;
        ctrl.totalTests = report.data.tests;

        ctrl.labels = report.labels;
        ctrl.hasTypes = !noTypeReportsList.includes(report.report_kind);

        ctrl.isDistrictReport = report.report_kind == 'district-tia-progress';
        if (ctrl.isDistrictReport) {
          if (report.data.schools) {
            report.data.schools.forEach(function(school) {
              ctrl.schools.push({id: school.id, name: school.school_name});
            });
          }
        }

        report.data.schools.forEach(function(school, schoolIndex) {
          ctrl.reportingTeachers.push(calculateSchoolTotals(report, school, schoolIndex));
          let index = 1;
          report.data.teachers.forEach(function(teacher) {
            if (teacher.school_id == school.id) {
              ctrl.reportingTeachers.push({
                schoolId: school.id,
                schoolName: school.school_name,
                name: teacher.first_name + ' ' + teacher.last_name,
                email: teacher.email,
                purchased: school.purchased,
                seats: teacher.usedSeats,
                pretests: teacher.pretest_count,
                posttests: teacher.posttest_count,
                matchingPosttests: teacher.matchingPosttests,
                academySkillProgress: teacher.academySkillProgress,
                academyProgressBadgeProps: getAcademyProgressBadgeProps(
                  teacher.academySkillProgress
                ),
                isSchool: false,
                isOdd: index % 2,
                isVisible: (!ctrl.isDistrictReport || schoolIndex == 0)
              });
              index = index + 1;
            }
          });
        });

        filterReportingTeachers();

        return report;
      })
      .catch(function(error) {
        $log.error("error in fetching report:",error);
        ctrl.loadingData = false;
      });
    }

    ReportingSchoolYearsService.ready().then(function () {
      initReportingYear();
      return fetchAndUpdateReport();
    })
      .then(function () {
        ctrl.inited = true;
      })
      .catch(function(error) {
        $log.error("error in updating report:",error);
        ctrl.inited = true;
      });
  }

  module.component('districtTiaProgress', {
    require: {parent: '^^xpReport'},
    template: require('./districtTIAProgress.jade'),
    controller: controller,
  });

})();

module.exports = {
  getAcademyProgressBadgeProps
};
